import { useEffect, useRef, useState } from "react";
import { fetchPost } from "../util/helpers";
import { useSearchParams } from "react-router-dom";
const SUCCESS_MSG =
  "Successfully connected your Youtube account! You may close the browser";
const ERROR_MSG = "An error occurred!";
const IN_PROGRESS_MSG = "Connecting your account...";
export default function YoutubeOAuth(props) {
  const [message, setMessage] = useState(IN_PROGRESS_MSG);
  const [searchParams, setSearchParams] = useSearchParams();
  const alreadyTriggered = useRef(false);
  const addYoutube = async () => {
    if (alreadyTriggered.current) {
      return;
    }
    try {
      alreadyTriggered.current = true;
      await fetchPost("/oauth/access_token/youtube", {
        code: searchParams.get("code"),
        scope: decodeURIComponent(searchParams.get("scope")),
        userDocId: searchParams.get("state"),
      });
      setMessage(SUCCESS_MSG);
    } catch (err) {
      setMessage(ERROR_MSG);
      return;
    }
  };
  useEffect(() => {
    const requiredParams =
      searchParams.has("scope") &&
      searchParams.has("state") &&
      searchParams.has("code");
    if (searchParams.has("error") || !requiredParams) {
      setMessage(
        `${ERROR_MSG} ${
          searchParams.has("error") ? searchParams.get("error_description") : ""
        }`,
      );
    } else if (requiredParams) {
      addYoutube();
    }
  }, [searchParams]);
  console.log(searchParams);

  return (
    <div style={{ textAlign: "center", verticalAlign: "middle" }}>
      {message}
    </div>
  );
}
